import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DownArrowLeft = createSvgIcon(
  <path d="M3.75 18.659 20.887 1.52l1.591 1.591L5.341 20.25H21v2.25H1.5V3h2.25v15.659Z" />,
  'DownArrowLeft'
);

export { DownArrowLeft };